<template>
  <div id="chart">
    <apexchart type="bar" height="170" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ['indicadores'],
  data() {
    return {
      chartOptions: {
        chart: {
          type: "bar",
          height: 380,
        },
        plotOptions: {
          bar: {
            barHeight: "100%",
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom",
            },
          },
        },
        colors: ["#1976D2", "#03A9F4", "#26C6DA"],
        dataLabels: {
          enabled: false,
          textAnchor: "start",
          style: {
            colors: ["#fff"],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ": " + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: ["Licenciatura", "Maestría", "Doctorado"],
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        tooltip: {
          theme: "dark",
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: function (val, opt) {
                return (
                  '<div class="legend-info">' +
                  "<span>" +
                  "<span>" +
                  opt.w.globals.labels[opt.dataPointIndex] +
                  ": " +
                  "</span>" +
                  "</div>"
                );
              },
            },
          },
        },
      },
    };
  },
  computed: {
    series: function () {
      return [
        {
          data: [this.indicadores.licenciatura_total, this.indicadores.maestria_total, this.indicadores.doctorado_total],
        },
      ];
    },
  },
};
</script>

<style scoped>
</style>